<ion-grid class="admin-menu">
  <ion-row>
    <ion-col
      size="12"
      size-md="6"
      *ngFor="let menuItem of menuItems"
      class="admin-menu__col"
    >
      <!-- 
        Agregamos el prefijo a la ruta '/admin/' porque este menu al estar en una
        pagina aparte no se puede relacionar con el router-outlet como child route.
      -->
      <div
        *ngIf="!menuItem.disabled"
        [routerLink]="routePrefix + menuItem.route"
        class="admin-menu__item"
        [ngClass]="{
          'admin-menu__item--current': menuItem.currentStep
        }"
      >
        <span class="admin-menu__title" translate>{{ menuItem.title }}</span>
        <svg-icon class="admin-menu__image" [src]="menuItem.icon"></svg-icon>
      </div>
      <div
        *ngIf="menuItem.disabled"
        class="admin-menu__item admin-menu__item--disabled"
      >
        <span class="admin-menu__title" translate>{{ menuItem.title }}</span>
        <svg-icon class="admin-menu__image" [src]="menuItem.icon"></svg-icon>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
